import React, { useEffect, useRef } from 'react';
import '../../Utils/Svg/Svg.scss';
import { projects } from '../../Data/Data';

import { useInView } from 'react-intersection-observer';

import { BsArrowRightCircleFill } from 'react-icons/bs';
import { FaCode } from 'react-icons/fa';
import '../Projects/Projects.scss';

const Projects = () => {
  const { ref: heading1, inView } = useInView({
    threshold: 0.9,
    // triggerOnce: true,
  });
  const { ref: heading2, inView: inView2 } = useInView({ triggerOnce: true });
  const revealaRef = useRef([]);

  const addToRef = (el) => {
    if (el && !revealaRef.current.includes(el)) {
      revealaRef.current.push(el);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('rotate', entry.isIntersecting);

          if (entry.isIntersecting) {
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.8 }
    );
    revealaRef.current.forEach((ref) => {
      observer.observe(ref);
    });
  }, []);
  const cursor = useRef();

  useEffect(() => {
    let mouse = { x: 300, y: 300 };
    let pos = { x: 0, y: 0 };
    const speed = 0.3; // between 0 and 1

    const updatePosition = () => {
      pos.x += (mouse.x - pos.x) * speed;
      pos.y += (mouse.y - pos.y) * speed;
      cursor.current.style.transform =
        'translate3d(' + pos.x + 'px ,' + pos.y + 'px, 0)';
    };

    const updateCoordinates = (e) => {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
    };

    window.addEventListener('mousemove', updateCoordinates);
    window.addEventListener('mouseover', updateCoordinates);

    function loop() {
      updatePosition();
      requestAnimationFrame(loop);
    }

    requestAnimationFrame(loop);
    return () => {
      window.removeEventListener('mousemove', updateCoordinates);
    };
  }, []);
  return (
    <>
      {/* <div ref={cursor} className="lg:block hidden cursor">
        <div class="cursor--inner flex items-center justify-center">
          <TiInfoLarge className="text-teal-400 text-3xl" />
        </div>
      </div> */}
      <div
        id="portfolio"
        className="  h-full bg-slate-900 w-full border-b-2 border-teal-300 pb-20"
      >
        <div className=" flex flex-col items-center justify-center gap-10">
          <div className=" flex flex-col items-center pt-5 justify-center ">
            <h1
              ref={heading1}
              bg-text="My Projects"
              className={` ${
                inView && 'headingRocks'
              } heading__text text-center text-teal-400  font-outfit sm:text-[5rem] text-[3rem] font-semibold mt-5`}
            >
              My Projects
            </h1>
            <p
              ref={heading2}
              className={`${
                inView2 && 'info'
              } text-teal-200 brightness-125 text-xl tracking-wide text-center px-5 mt-5 font-outfit md:px-36`}
            >
              Even though i have done a lot of projects throughout my journey
              with React, in here i have included only the projects that i
              consider my best. I have developed these websites completely with
              my own way of doing things and solving problems. So these projects
              are a great summary of what can be expected from me.
            </p>
          </div>
        </div>
        <div className="grid drop-shadow-2xl shadow-white md:grid-cols-2 lg:px-44 sm:px-10 flex-wrap px-5  mt-5 gap-10">
          {projects.map((project) => {
            return (
              <div
                ref={addToRef}
                className={`$ hover:shadow-xl hover:shadow-teal-400 shadow-md shadow-gray-500 rounded-tl-3xl  rounded-br-3xl bg-gradient-to-tr from-slate-800 to-slate-900 relative flex flex-col gap-3 p-5 border-2 border-teal-400 m-auto w-full h-full`}
              >
                <p className="bg-slate-900 bg-gradient-to-r from-teal-400 to-teal-300 text-black font-semibold tracking-wide font-outfit border-2 border-slate-600 rounded-md shadow-sm shadow-teal-200  text-center  rounded-tr-full rounded-bl-full py-1  text-lg">
                  {project.title}
                </p>
                <img
                  src={project.img}
                  alt="project"
                  className="border-b-2 border-teal-400  "
                />

                <p className="w-fit bg-gradient-to-r from-teal-400 to-teal-300 border-2 border-slate-600 text-black  font-semibold  p-2 font-outfit tracking-wider text-base rounded-md">
                  {project.description}
                </p>
                <div className=" flex items-center gap-3 text-teal-400 font-outfit text-xl">
                  <a
                    className="group cardbutton w-16 h-11 relative bg-gradient-to-tr from-slate-800 to-slate-900  p-2 rounded-md border border-teal-400 after:content-['Code'] hover:after:content-[''] before:content-[''] before:absolute before:w-0 before:h-full before:hover:w-full before:top-0 before:left-0 before:bg-teal-400 before:transition-[width,0.4s,ease-in-out]"
                    href={project.code}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="relative">
                      <FaCode className=" m-auto absolute top-1 group-hover:w-full w-0  text-slate-900" />
                    </p>{' '}
                  </a>{' '}
                  <a
                    className="group after:flex after:items-center after:justify-center cardbutton w-16 h-11 relative bg-gradient-to-tr from-slate-800 to-slate-900  p-2 rounded-md border border-teal-400 after:content-['Live']  hover:after:content-[''] before:content-[''] before:absolute before:w-0 before:h-full before:hover:w-full before:top-0 before:left-0 before:bg-teal-400 before:transition-[width,0.4s,ease-in-out]"
                    href={project.live}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="relative">
                      <BsArrowRightCircleFill className=" m-auto absolute top-1 group-hover:w-full w-0  text-slate-900" />
                    </p>{' '}
                  </a>{' '}
                </div>
                {/* <h1 className="text-teal-300">Technologies Used : </h1> */}
                <p className="flex flex-wrap gap-1 w-fit py-2  ">
                  <span className="bg-gradient-to-r from-teal-400 to-teal-300 p-1 px-2 text-black font-semibold tracking-wide font-outfit border-2 border-slate-600 rounded-md">
                    {project.tech.react}
                  </span>{' '}
                  ,
                  {project.tech.redux && (
                    <span className="bg-gradient-to-r from-teal-400 to-teal-300 p-1 px-2 text-black font-semibold tracking-wide font-outfit border-2 border-slate-600 rounded-md">
                      {project.tech.redux}
                    </span>
                  )}
                  <span className="bg-gradient-to-r from-teal-400 to-teal-300 p-1 px-2 text-black font-semibold tracking-wide font-outfit border-2 border-slate-600 rounded-md">
                    {project.tech.css}
                  </span>{' '}
                  {project.tech.firebase && (
                    <span className="bg-gradient-to-r from-teal-400 to-teal-300 p-1 px-2 text-black font-semibold tracking-wide font-outfit border-2 border-slate-600 rounded-md">
                      {project.tech.firebase}
                    </span>
                  )}{' '}
                  {project.tech.next && (
                    <span className="bg-gradient-to-r from-teal-400 to-teal-300 p-1 px-2 text-black font-semibold tracking-wide font-outfit border-2 border-slate-600 rounded-md">
                      {project.tech.next}
                    </span>
                  )}
                </p>

                {/* <button className="w-full p-2 hover:from-slate-900 hover:to-slate-800 bg-gradient-to-tr from-slate-800 to-slate-900  rounded-md border border-slate-800 shadow-sm text-green-400  tracking-wider text-2xl shadow-green-400">
                Know More About This Project
              </button> */}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Projects;
